import React, {Component} from 'react';
import {addUrlProps, configureUrlQuery, UrlQueryParamTypes} from 'react-url-query';
import PropTypes from 'prop-types'
import { createBrowserHistory } from 'history';
import { limit } from './helpers';
import VenuesList from './components/VenuesList';
import VenuesFilters from "./components/VenuesFilters";
import { ScaleLoader } from 'react-spinners';
import _ from 'lodash';


const urlPropsQueryConfig = {
    locations: {type: UrlQueryParamTypes.string},
    capacity: {type: UrlQueryParamTypes.string},
    typeVenue: {type: UrlQueryParamTypes.string}
};

const history = createBrowserHistory();
configureUrlQuery({history});

class App extends Component {

    static propTypes = {
        capacity: PropTypes.string,
        locations: PropTypes.string,
        typeVenue: PropTypes.string,
        onChangeLocations: PropTypes.func,
        onChangeCapacity: PropTypes.func,
        onChangeTypeVenue: PropTypes.func,
    };

    static defaultProps = {
        capacity: '',
        locations: '',
        typeVenue: ''
    };

    constructor(props) {
        super(props);

        const capacity = props.capacity.split(",");
        const locations = props.locations.split(",");
        const typeVenue = props.typeVenue.split(",");

        this.state = {
            venues: [],
            filters: [],
            locations,
            capacity,
            typeVenue,
            hasMoreVenues: true,
            offset: 0,
            loading: true,
        };
    }

    componentDidMount() {
        history.listen(() => this.forceUpdate());

        this.fetchVenues(0,limit,[],[], [], 1);
    }


    mapStateToFilter = () => {
        const { filters } = this.state;
        this.state.locations.map((loc) => {
            if(loc){ filters.locaties[loc].active = true; }
        });
        this.state.capacity.map((cap) => {
            if(cap){ filters.capaciteit[cap].active = true; }
        });

        this.state.typeVenue.map((typeVenue) => {
            if(typeVenue){ filters.type[typeVenue].active = true; }
        });

        this.setState({filters});
    };


    fetchVenues = async (offset = 0, limit = 6, locations = [], capacity = [], typeVenue = [], buildFilters = 0, append = false) => {
        if(buildFilters == 0 && !append){
            this.setState({loading: true});
        }

        const url = `/filter/venues?offset=${offset}&limit=${limit}&locations=${locations.join()}&capacity=${capacity.join()}&type=${typeVenue.join()}&buildFilters=${buildFilters}`;
        const response = await fetch(url);
        const data = await response.json();
        let { filters, venues } = data;
        if(buildFilters){
            venues = venues.slice(0,limit);
            this.setState({ venues, filters, offset: limit}, this.mapStateToFilter);
        } else if(append){
            const appendedVenues = [...this.state.venues, ...venues];
            const uniqueVenues = _.uniqBy(appendedVenues, 'id');
           // const orderedVenues = _.orderBy(uniqueVenues, ['date'],['desc']);
            const hasMoreVenues = venues.length > 0;
            this.setState({venues: uniqueVenues, hasMoreVenues, offset: offset + limit});
        }
        else {
            this.setState({venues});
        }
        this.setState({loading: false});
    };

    loadMore = () => {
        this.fetchVenues(this.state.offset,limit,this.state.locations,this.state.capacity, this.state.typeVenue,0, true);
    };

    setFilterOption = (filter, option, checked) => {
        const filters = {...this.state.filters};
        filters[filter][option.id].active = checked;

        const locations = [];
        Object.values(filters['locaties']).forEach((loc)=> {
            if(loc.active){
                locations.push(loc.id);
            }
        });

        const capacity = [];
        Object.values(filters['capaciteit']).forEach((cap)=> {
            if(cap.active){
                capacity.push(cap.id);
            }
        });

        const typeVenue = [];
        Object.values(filters['type']).forEach((type)=> {
            if(type.active){
                typeVenue.push(type.id);
            }
        });

        this.setState({filters, locations, capacity, typeVenue, hasMoreVenues: true}, this.filterVenues);
    };


    filterVenues = () => {
        this.props.onChangeLocations(this.state.locations.join());
        this.props.onChangeCapacity(this.state.capacity.join());
        this.props.onChangeTypeVenue(this.state.typeVenue.join());
        this.setState({offset: 0}, () => this.fetchVenues(this.state.offset,limit,this.state.locations,this.state.capacity, this.state.typeVenue,0, false))
    };

    render() {
        return (
            <div className="row">
                <div className="sidebar-content col-md-3 ml-md-auto">
                    {this.state.filters.length === 0 && this.state.loading ?
                        <div className="text-primary font-size-lg text-center p-3">
                            <ScaleLoader/>
                        </div>
                        :
                        <VenuesFilters filters={this.state.filters} setFilterOption={this.setFilterOption}/>
                    }
                </div>
                <div className="col-md-9 col-lg-8 top-md-min-4 arrow-before bg-white ml-auto">
                    <header>
                        <div className="pb-5 bg-white">
                            <h1 className="text-primary d-inline-block">Zaalverhuur</h1>
                        </div>
                    </header>
                    {this.state.loading ?
                        <div className="text-primary font-size-lg text-center p-3">
                            <ScaleLoader/>
                        </div>
                        :
                        <VenuesList venues={this.state.venues} hasMore={this.state.hasMoreVenues} loadMore={this.loadMore}/>
                    }
                </div>
            </div>
        );
    }
}

export default addUrlProps({urlPropsQueryConfig})(App);


